var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"btn_menu",staticStyle:{"text-transform":"none"},attrs:{"rounded":"","color":"blue","width":"170px","dark":""},on:{"click":_vm.goodSearch}},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }